module.exports = __webpack_public_path__ + "37d0b12119d68608f37124158a36da77.svg";